
import NewProductSettingsService from './NewProductSettingsService';

export { default } from './NewProductSettingsService';
export const newProductSettingsService = new NewProductSettingsService();